export enum WoundsizeMeasureSource {
  AI_PREDICTION = 'ai-prediction',
  USER_EDIT = 'user-edit',
}
